import AppLayout from '@/layout/AppLayout.vue';
import { supabase } from '@/supabase';
import { createRouter, createWebHashHistory } from 'vue-router';
const router = createRouter({
    history: createWebHashHistory(), // Hash mode
    routes: [
        {
            path: '/dash',
            component: AppLayout,
            children: [
                {
                    path: '/dash',
                    name: 'dashboard',
                    component: () => import('@/views/Dashboard.vue')
                },
                {
                    path: '/leaderboard-publishing',
                    name: 'leaderboard-publishing',
                    component: () => import('@/views/Settings/LeaderboardPublish.vue')
                },
                {
                    path: '/participantdash',
                    name: 'participantdash',
                    component: () => import('@/views/ParticipantDash.vue')
                },
                {
                    path: '/admindash',
                    name: 'admindash',
                    component: () => import('@/views/pages/Admin/Admindash.vue')
                },
                {
                    path: '/brand-sponsership',
                    name: 'brand-sponsership',
                    component: () => import('@/views/pages/Admin/BrandSponser.vue')
                },
                {
                    path: '/analytics-overview',
                    name: 'analytics-overview',
                    component: () => import('@/views/pages/Admin/AnalyticsOverview.vue')
                },
                {
                    path: '/quiz-analytics',
                    name: 'quiz-analytics',
                    component: () => import('@/views/pages/Admin/QuizAnalytics.vue')
                },
                {
                    path: '/quiz-analytics-overview/:id',
                    name: 'quiz-analytics-overview',
                    component: () => import('@/views/pages/Admin/QuizAnalyticsOverview.vue')
                },
                {
                    path: '/quiz-analytics-logs/:id?',
                    name: 'quiz-analytics-logs',
                    component: () => import('@/views/pages/Admin/QuizAnalyticsLogs.vue')
                },
                {
                    path: '/editslots/:id',
                    name: 'edit-slots',
                    component: () => import('@/views/pages/Admin/EditSlots.vue')
                },
                {
                    path: '/sansthalist',
                    name: 'sansthalist',
                    component: () => import('@/views/pages/Admin/SansthaList.vue')
                },
                {
                    path: '/particularadminsanstha/:id',
                    name: 'particularsanstha',
                    component: () => import('@/views/pages/Admin/ParticularAdminSanstha.vue')
                },
                {
                    path: '/alladminquizes',
                    name: 'alladminquizes',
                    component: () => import('@/views/pages/Admin/AllAdminQuizes.vue')
                },

                // {
                //     path: '/profile',
                //     name: 'profile',
                //     component: () => import('@/views/pages/Profile.vue')
                // },
                {
                    path: '/educatordash/:id?',
                    name: 'educatordash',
                    component: () => import('@/views/EducatorDashboard.vue')
                },
                {
                    path: '/educatordashrole/:id',
                    name: 'educatordashrole',
                    component: () => import('@/views/EducatorDashboardRole.vue')
                },
                {
                    path: '/createGenQuiz/:id?',
                    name: 'createGenQuiz',
                    component: () => import('@/views/pages/CreateGenQuiz.vue')
                },
                {
                    path: '/QuizDashboard',
                    name: 'QuizDashboard',
                    component: () => import('@/views/pages/QuizDash.vue')
                },
                {
                    path: '/userDash',
                    name: 'UserDashboard',
                    component: () => import('@/views/UserDashboard.vue')
                },
                {
                    path: '/QuestionBank/:id?',
                    name: 'QuestionBank',
                    component: () => import('@/views/pages/QuestionBank.vue')
                },
                {
                    path: '/SansthaQuiz',
                    name: 'SansthaQuiz',
                    component: () => import('@/views/pages/SansthaQuiz/SansthaQuiz.vue')
                },
                {
                    path: '/SansthaQuizEdu',
                    name: 'SansthaQuizEdu',
                    component: () => import('@/views/pages/SansthaQuiz/SansthaQuizEdu.vue')
                },
                {
                    path: '/CreateSansthaQuiz',
                    name: 'CreateSansthaQuiz',
                    component: () => import('@/views/pages/SansthaQuiz/CreateSansthaQuiz.vue')
                },
                {
                    path: '/EditSansthaQuiz/:id',
                    name: 'EditSansthaQuiz',
                    component: () => import('@/views/pages/SansthaQuiz/EditSansthaQuiz.vue')
                },
                {
                    path: '/createDailyQuiz/:id?',
                    name: 'createDailyQuiz',
                    component: () => import('@/views/pages/DailyQuiz/CreateDailyQuiz.vue')
                },
                {
                    path: '/dailyQuizes',
                    name: 'dailyQuizes',
                    component: () => import('@/views/pages/DailyQuiz/AllDailyQuiz.vue')
                },
                {
                    path: '/quizscoringmanagement/:id',
                    name: 'quizscoringmanagement',
                    component: () => import('@/views/pages/DailyQuiz/ScoringManagement.vue')
                },
                {
                    path: '/participantDailyQuizes',
                    name: 'participantDailyQuizes',
                    component: () => import('@/views/pages/DailyQuiz/ParticipantDailyQuizes.vue')
                },
                {
                    path: '/participantAttemptedDailyQuiz',
                    name: 'participantAttemptedDailyQuiz',
                    component: () => import('@/views/pages/DailyQuiz/ParticipantAttemptedDailyQuiz.vue')
                },
                {
                    path: '/chooseTypeQuiz',
                    name: 'chooseTypeQuiz',
                    component: () => import('@/views/pages/DailyQuiz/ChooseTypeQuiz.vue')
                },

                {
                    path: '/dailyparticularquiz/:sanstha_name?/:id',
                    name: 'dailyparticularquiz',
                    component: () => import('@/views/pages/DailyQuiz/DailyParticularQuiz.vue')
                },
                {
                    path: '/userhistory/:id',
                    name: 'userHistory',
                    component: () => import('@/views/pages/UserHistory.vue')
                },
                {
                    path: '/allQuestions',
                    name: 'allQuestions',
                    component: () => import('@/components/QuestionBank/QuestionTable.vue')
                },
                {
                    path: '/getAllQuiz/:id?',
                    name: 'getAllQuiz',
                    component: () => import('@/views/pages/GetAllQuiz.vue')
                },
                {
                    path: '/getAllAttempts',
                    name: 'getAllAttempts',
                    component: () => import('@/views/pages/GetAllAttempts.vue')
                },
                {
                    path: '/getAllRegisteredUsers',
                    name: 'getAllRegisteredUsers',
                    component: () => import('@/views/pages/GetAllRegisteredUsers.vue')
                },
                {
                    path: '/luckywinners',
                    name: 'luckywinners',
                    component: () => import('@/views/pages/DailyQuiz/LuckyWinner.vue')
                },
                {
                    path: '/uikit/formlayout',
                    name: 'formlayout',
                    component: () => import('@/views/uikit/FormLayout.vue')
                },
                {
                    path: '/uikit/createQuiz',
                    name: 'createQuiz',
                    component: () => import('@/views/uikit/CreateQuiz.vue')
                },
                {
                    path: '/uikit/input',
                    name: 'input',
                    component: () => import('@/views/uikit/InputDoc.vue')
                },
                {
                    path: '/uikit/button',
                    name: 'button',
                    component: () => import('@/views/uikit/ButtonDoc.vue')
                },
                {
                    path: '/uikit/table',
                    name: 'table',
                    component: () => import('@/views/uikit/TableDoc.vue')
                },
                {
                    path: '/uikit/list',
                    name: 'list',
                    component: () => import('@/views/uikit/ListDoc.vue')
                },
                {
                    path: '/uikit/tree',
                    name: 'tree',
                    component: () => import('@/views/uikit/TreeDoc.vue')
                },
                {
                    path: '/uikit/panel',
                    name: 'panel',
                    component: () => import('@/views/uikit/PanelsDoc.vue')
                },
                {
                    path: '/uikit/overlay',
                    name: 'overlay',
                    component: () => import('@/views/uikit/OverlayDoc.vue')
                },
                {
                    path: '/uikit/media',
                    name: 'media',
                    component: () => import('@/views/uikit/MediaDoc.vue')
                },
                {
                    path: '/uikit/message',
                    name: 'message',
                    component: () => import('@/views/uikit/MessagesDoc.vue')
                },
                {
                    path: '/uikit/file',
                    name: 'file',
                    component: () => import('@/views/uikit/FileDoc.vue')
                },
                {
                    path: '/particularSansthaQuiz/:id',
                    name: 'ParticularSansthaQuiz',
                    component: () => import('@/views/pages/SansthaQuiz/ParticularSansthaQuiz.vue') // adjust path accordingly
                },
                {
                    path: '/particularSansthaQuizAttempt/:id',
                    name: 'particularSansthaQuizAttempt',
                    component: () => import('@/views/pages/SansthaQuiz/ParticularSansthaQuizStart.vue') // adjust path accordingly
                },
                {
                    path: '/uikit/menu',
                    name: 'menu',
                    component: () => import('@/views/uikit/MenuDoc.vue')
                },
                {
                    path: '/uikit/charts',
                    name: 'charts',
                    component: () => import('@/views/uikit/ChartDoc.vue')
                },
                {
                    path: '/uikit/misc',
                    name: 'misc',
                    component: () => import('@/views/uikit/MiscDoc.vue')
                },
                {
                    path: '/uikit/timeline',
                    name: 'timeline',
                    component: () => import('@/views/uikit/TimelineDoc.vue')
                },
                {
                    path: '/pages/empty',
                    name: 'empty',
                    component: () => import('@/views/pages/Empty.vue')
                },
                {
                    path: '/pages/crud',
                    name: 'crud',
                    component: () => import('@/views/pages/Crud.vue')
                },
                {
                    path: '/documentation',
                    name: 'documentation',
                    component: () => import('@/views/pages/Documentation.vue')
                },
                {
                    path: '/userprofile',
                    name: 'userprofile',
                    component: () => import('@/views/pages/ProfileMianScreen.vue')
                },
                {
                    path: '/manage-users',
                    name: 'manageusers',
                    component: () => import('@/views/pages/ManageUsers.vue')
                },
                {
                    path: '/addManager',
                    name: 'addManager',
                    component: () => import('@/views/pages/AddManager.vue')
                },
                {
                    path: '/role-management',
                    name: 'rolemanagement',
                    component: () => import('@/views/pages/RoleManagement.vue')
                },
                {
                    path: '/getleadershipboard',
                    name: 'getleadershipboard',
                    component: () => import('../views/pages/DailyQuiz/GetLeadershipboard.vue')
                },
                {
                    path: '/getAdminleadershipboard',
                    name: 'getAdminleadershipboard',
                    component: () => import('../views/pages/DailyQuiz/GetAdminLeadershipboard.vue')
                },

                {
                    path: '/GetDailyQuizes',
                    name: 'GetDailyQuizes',
                    component: () => import('../views/pages/DailyQuiz/GetDailyQuizes.vue')
                },
                {
                    path: '/GetSansthaQuizes',
                    name: 'GetSansthaQuizes',
                    component: () => import('../views/pages/SansthaQuiz/GetSansthaQuizes.vue')
                },
                {
                    path: '/listTempletes',
                    name: 'listTemplates',
                    component: () => import('../views/pages/Templates/ListOfTemplets.vue')
                },
            ]
        },
        {
            path: '/profile',
            name: 'profile',
            component: () => import('@/views/pages/Profile.vue')
        },
        {
            path: '/loading',
            name: 'loading',
            component: () => import('@/views/pages/DailyQuiz/LoaderPage.vue')
        },
        {
            path: '/leaderboard/:id/:date',
            name: 'leaderboard',
            component: () => import('@/views/pages/Leadershipboard.vue')
        },
        {
            path: '/get-sanstha-quiz-leadershipboard/:id',
            name: 'getSansthaQuizleadershipboard',
            component: () => import('../views/pages/SansthaQuiz/getLeaderboard.vue')
        },
        {
            path: '/userreport/:quizId/:id',
            name: 'userreport',
            component: () => import('@/views/pages/DailyQuiz/UserReport.vue')
        },
        {
            path: '/quizreport/:id',
            name: 'quizreport',
            component: () => import('@/views/pages/DailyQuiz/QuizReport.vue')
        },
        {
            path: '/alladminparticipants',
            name: 'alladminparticipants',
            component: () => import('@/views/pages/Admin/AllParticipants.vue')
        },
        {
            path: '/userlist/:id',
            name: 'userList',
            component: () => import('@/views/pages/DailyQuiz/UserList.vue')
        },
        {
            path: '/eduleaderboard/:id/:date',
            name: 'eduleaderboard',
            component: () => import('@/views/pages/EduLeadership.vue')
        },
        {
            path: '/getLeadershipBoard',
            name: 'getleadershipBoard',
            component: () => import('@/views/pages/LeadershipGet.vue')
        },
        {
            path: '/sansthaDailyQuiz/:id',
            name: 'sansthaDailyQuiz',
            component: () => import('@/views/pages/DailyQuiz/SansthaDailyQuiz.vue')
        },
        {
            path: '/',
            name: 'landing',
            component: () => import('@/views/pages/Landing.vue')
        },
        {
            path: '/AddQuestionSanstha/:id',
            name: 'AddQuestionSanstha',
            component: () => import('@/views/pages/SansthaQuiz/AddQuestionSanstha.vue')
        },
        {
            path: '/getParticularQuestion/:id',
            name: 'getParticularQuestion',
            component: () => import('@/views/pages/GetParticularQuestion.vue')
        },
        {
            path: '/getParticularQuestionSanstha/:id',
            name: 'getParticularQuestionSanstha',
            component: () => import('@/views/pages/SansthaQuiz/GetParticularQuestionSanstha.vue')
        },
        {
            path: '/startQuiz/:id',
            name: 'startQuiz',
            component: () => import('@/views/pages/StartQuiz.vue')
        },
        {
            path: '/startSansthaQuiz/:id',
            name: 'startSansthaQuiz',
            component: () => import('@/views/pages/SansthaQuiz/StartSansthaQuiz.vue')
        },
        {
            path: '/previewPage',
            name: 'previewPage',
            component: () => import('@/views/pages/PreviewPage.vue')
        },
        {
            path: '/QuizResult/:id',
            name: 'quizResult',
            component: () => import('@/views/pages/QuizResult.vue')
        },
        {
            path: '/SansthaQuizResult/:id',
            name: 'SansthaQuizResult',
            component: () => import('@/views/pages/SansthaQuiz/SansthaQuizResult.vue')
        },
        {
            path: '/particularDailyQuizDetail',
            name: 'particularDailyQuizDetail',
            component: () => import('@/views/pages/DailyQuiz/ParticularQuizDetail.vue')
        },

        {
            path: '/dailyquizattempt/:id',
            name: 'dailyquizattempt',
            component: () => import('@/views/pages/DailyQuiz/DailyQuizAttempt.vue')
        },
        {
            path: '/QuizResult1',
            name: 'quizResult1',
            component: () => import('@/views/pages/QuizResult1.vue')
        },
        {
            path: '/addQuestion/:id',
            name: 'addQuestion',
            component: () => import('@/views/pages/AddQuestion.vue')
        },
        {
            path: '/editQuizOfQuestions/:id',
            name: 'editQuizOfQuestions',
            component: () => import('@/views/pages/EditQuiz.vue')
        },
        {
            path: '/editQuestion/:id',
            name: 'editQuestion',
            component: () => import('@/views/pages/EditQuestion.vue')
        },
        {
            path: '/pages/notfound',
            name: 'notfound',
            component: () => import('@/views/pages/NotFound.vue')
        },
        {
            path: '/auth/login',
            name: 'login',
            component: () => import('@/views/pages/auth/Login.vue')
        },
        {
            path: '/auth/forgotpassword',
            name: 'forgotpassword',
            component: () => import('@/views/pages/auth/ForgotPassword.vue')
        },
        {
            path: '/auth/handle-token',
            name: 'HandleToken',
            component: () => import('@/views/pages/auth/HandleToken.vue')
        },
        {
            path: '/auth/handle-invite-user',
            name: 'HandleInviteUser',
            component: () => import('@/views/pages/auth/HandleInviteUser.vue')
        },
        {
            path: '/auth/set-password',
            name: 'Setpassword',
            component: () => import('@/views/pages/auth/SetPassword.vue')
        },
        {
            path: '/auth/reset-password',
            name: 'resetpassword',
            component: () => import('@/views/pages/auth/ResetPassword.vue')
        },
        {
            path: '/auth/guestLogin',
            name: 'guestLogin',
            component: () => import('@/views/pages/auth/GuestLogin.vue')
        },
        {
            path: '/auth/access',
            name: 'accessDenied',
            component: () => import('@/views/pages/auth/Access.vue')
        },
        {
            path: '/auth/error',
            name: 'error',
            component: () => import('@/views/pages/auth/Error.vue')
        },
        {
            path: '/oathUser',
            name: 'oathUser',
            component: () => import('@/views/pages/OathUser.vue')
        },
        {
            path: '/loading',
            name: 'LoadingRedirect',
            component: () => import('../views/pages/LoaderRedirect.vue')
        },
        {
            path: '/countdown/:id',
            name: 'countdown',
            component: () => import('../views/pages/Countdown.vue')
        },
        {
            path: '/createTemplate',
            name: 'createTemplate',
            component: () => import('../views/pages/Templates/CreateTemplate.vue')
        },

        {
            path: '/template/:title',
            name: 'TemplatePreview',
            component: () => import('../views/pages/Templates/ParticularTemplate.vue'),
            props: true
        },
        {
            path: '/message-preview/:id-:quizTitle-:userName',
            name: 'MessagePreview',
            component: () => import('../views/pages/Templates/MessagePreview.vue'),
            props: true
        },
        {
            path: '/quiz-history',
            name: 'quizHistory',
            component: () => import('../views/pages/QuizHistory.vue'),
            props: true
        },
        {
            path: '/luckywinnerdisplay',
            name: 'luckywinnerdisplay',
            component: () => import('../views/pages/LuckyWinnerDisplay.vue')
        },
        {
            path: '/landingpage2',
            name: 'landingpage2',
            component: () => import('../views/pages/LandingPage2.vue')
        },
        {
            path: '/forgot-password',
            name: 'forgotPassword',
            component: () => import('@/views/pages/auth/ForgotPassword.vue')
        },
        {
            path: '/jdLogin',
            name: 'jdLogin',
            component: () => import('@/views/pages/Jd-login.vue')
        },
        {
            path: '/auth/callback',
            name: 'AuthCallback',
            component: () => import('@/views/pages/auth/AuthCallback.vue')
        }
    ]
});


router.beforeEach(async (to, from, next) => {
    //  List of public routes (exact matches)
    const publicPages = [
        '/auth/login',
        '/oathUser',
        '/loading',
        '/forgot-password',
        '/jdLogin',
        '/auth/callback',
        '/auth/reset-password',
        '/auth/handle-token',
        '/auth/handle-invite-user',
        '/auth/set-password',
        '/',
    ];

    //  Helper to check if page is public
    const isPublicPage = (path) => {
        if (publicPages.includes(path)) return true;

        // Dynamic public routes
        const dynamicPublicRoutes = [
            /^\/leaderboard\/\d+\/.+$/
            // /^\/dailyparticularquiz\/\d+$/ // ✅ allow daily quiz links
        ];

        return dynamicPublicRoutes.some((regex) => regex.test(path));
    };

    const authRequired = !isPublicPage(to.path);

    //  Get localStorage session first (life-long session support)
    const localToken = localStorage.getItem('access_token');
    const localRole = localStorage.getItem('role');
    const localUserId = localStorage.getItem('user_id');
    const hasLocalSession = !!(localToken && localRole && localUserId);
    //  Get Supabase session (will refresh automatically if configured)
    const {
        data: { session }
    } = await supabase.auth.getSession();
    const isLoggedIn = hasLocalSession || !!session;
    if (to.name === 'login' && isLoggedIn) {
        return next('/');
    }
    if (!authRequired) return next();
    if (hasLocalSession) {
        if (to.meta?.role && to.meta.role !== localRole) {
            return next('/auth/login');
        }
        return next();
    }

    //  Fall back to Supabase session
    if (session) {
        if (to.meta?.role && to.meta.role !== session.user.role) {
            return next('/auth/login');
        }
        return next();
    }
    sessionStorage.setItem('redirectAfterLogin', to.fullPath);
    return next('/auth/login');
});

router.afterEach((to) => {
    if (window.gtag) {
        window.gtag('config', 'G-WZM46RJ1ZF', {
            page_path: to.fullPath
        });
    }
});

export default router;
